export const whenIdle = () => {
  return new Promise<void>((resolve) => {
    requestIdleCallback(() => {
      resolve()
    })
  })
}
